"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoggerCore = void 0;
const tslib_1 = require("tslib");
tslib_1.__exportStar(require("@video/log-node"), exports);
var logger_core_1 = require("./logger-core");
Object.defineProperty(exports, "LoggerCore", { enumerable: true, get: function () { return logger_core_1.LoggerCore; } });
tslib_1.__exportStar(require("./logger-http-writer"), exports);
//# sourceMappingURL=index.js.map